import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class DailyRevenue extends AbstractReport {

    static get AMOUNT() {

        return 'amount';
    }

    static get MTD() {

        return 'mtd';
    }

    static get YTD() {

        return 'ytd';
    }

    static get SINGLE() {

        return 'single';
    }

    static get ADJUST() {

        return 'adjust';
    }

    static get REFUND() {

        return 'refund';
    }

    static get REVENUE() {

        return 'revenue';
    }

    static get SINGLE_REFUND() {

        return 'single_refund';
    }
}

AccessorsMutatorsDecorator(
    'grand_total',
    'grand_total_payment',
    'grand_total_revenue',
    'opening_balance',
    'closing_balance',
    'change',
    'groups',
)(DailyRevenue);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/daily-activity/daily-revenue.model.js